import { AlertTriangle, Info } from "lucide-react";
import { isRoll29 } from "@/lib/labels";

const steps = ({ w, h }) => {
  const roll = Math.min(w, h);
  const len = Math.max(w, h);
  return [
    `Load the ${roll} mm roll in the QL-700 (for ${w} × ${h} mm labels).`,
    "Use Chrome or Edge on Windows. Click Print on this page.",
    "Destination / Printer: Brother QL-700.",
    `More settings → Paper size: ${roll}mm x ${len}mm (or ${roll}mm continuous with length ${len} mm).`,
    "Margins: None · Scale: Default (100%) — never \"Fit to page\" · Headers and footers: off.",
    "Print. Each label comes out one per page, at its real size.",
  ];
};

export const BrotherGuide = ({ size }) => (
  <details className="max-w-5xl mx-auto px-6 mb-6 group" data-testid="brother-guide" open>
    <summary className="cursor-pointer text-sm text-[#D4AF37] flex items-center gap-2" data-testid="brother-guide-toggle">
      <Info className="w-4 h-4" /> Printing on a Brother QL-700 (Windows · Chrome / Edge)
    </summary>
    <div className="mt-3 rounded-xl border border-[#2E252A] bg-[#161214] p-5 text-sm text-[#A89F91] space-y-3">
      <ol className="list-decimal pl-5 space-y-1.5" data-testid="brother-guide-steps">
        {steps(size).map((s) => <li key={s}>{s}</li>)}
      </ol>
      <div className="flex gap-2 text-[#F5F0EB]" data-testid="brother-guide-mismatch">
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-[#E5A93C]" />
        <p>
          The paper size in the Brother driver must be the same as the size chosen here ({size.w} × {size.h} mm). If the label comes out smaller, cut off, with a big blank part, or the printer says
          “O rolo de etiquetas ou a fita dentro da máquina não corresponde ao seleccionado na aplicação”, fix the driver once:
          Windows Settings → Bluetooth & devices → Printers & scanners → Brother QL-700 → Printing preferences → Paper size: {Math.min(size.w, size.h)}mm{isRoll29(size) ? " (continuous)" : ""}, Length {Math.max(size.w, size.h)} mm, Orientation Landscape → OK. Then print again.
        </p>
      </div>
      <p className="text-xs text-[#6E665D]">If the size is not in the list, update the Brother QL-700 driver from support.brother.com. The PDF button is a backup: open it and print at Actual size.</p>
    </div>
  </details>
);
